import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { formatMinutesToTimeFormat, makeStringStrictlyCapitalize } from '../../js/utility';
import { getCleanUrl, toBool } from '../../utils/Helper';
import CustomPressable from '../../components/customPressable/customPressable';
import { ImageComp } from '../../components/Image/Image';
import { HEART } from '../../assets';

const SpaBookingSummary = (props) => {
    const { currentWidget, bookingObj, handleNext, handleGoBack  } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();

    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice);
    const dateFormat = extraConfigParam?.DATE_FORMAT;
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;

    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;

    const handleGoNext = () => {
        const payload = {
            serviceType: "spa",
            // dateTime: `${selectedTechnicianDetails.availableDate}T${formatMinutesToHHMMSS(selectedTechnicianDetails.startTime)}`,
            serviceId: JSON.parse(bookingObj?.selectedService.service.id),
            spaLocationId: bookingObj?.spaLocationId,
            technicianId: bookingObj?.selectedTechnicianDetails.technicianId,
            guestNotes: bookingObj?.additionalDetails.guestNotes,

            requestedType: bookingObj?.preferences.gender,

            addOnServiceId: bookingObj?.selectedAddon.reduce((acc,curr)=>{acc.push(curr.id); return acc;},[]),
            spaServicePrice: bookingObj?.selectedService.service.price + bookingObj?.selectedAddon.reduce((acc,curr)=>{  return acc + curr.price;},0),
            spaTechnicianPrice: bookingObj?.selectedTechnicianDetails.technicianPrice,
            duration: bookingObj?.selectedService.service.duration
        
        };
        if (!bookingObj?.updateReservationDetails) {

            payload['requestedType'] = bookingObj?.preferences.gender;

            if (bookingObj?.additionalDetails.mobileNumber) {
                payload['mobileNumber'] = bookingObj?.additionalDetails.mobileNumber
            }
            if (bookingObj?.additionalDetails.email) {
                payload['email'] = bookingObj?.additionalDetails.email
            }

            console.log("makespabooking payload", payload);
            handleNext(payload);

        } else {

            payload['appointmentId'] = bookingObj?.updateReservationDetails.id;

            console.log("updatespabooking payload", payload);
            handleNext(payload);
        }
    };


    return (
        <View style={getStyles(['widgetRootContainer', 'spaBookingRootContainer'])} id='spaBookingRootContainer'>
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'spaBookingMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='spaBookingMainContainer'
            >
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'spaBookingHeaderContainer'])} id='spaBookingHeaderContainer'>
                    {currentWidget?.widgetHeaderImageUrl && 
                        <ImageComp
                            source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                            style={getStyles(['widgetmainContainerHeaderImg', 'spaBookingHeaderImg'])} id={"spaBookingHeaderImg"}
                        />
                    }
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'spaBookingHeaderTitleContainer'])} id='spaBookingHeaderTitleContainer'>
                        <ImageComp source={HEART} style={getStyles(["spaBookingHeaderTitleImage"])} id="spaBookingHeaderTitleImage"/>

                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'spaBookingHeaderTitle'])} id='spaBookingHeaderTitle'>
                            {t(`spaBooking.summary`)}
                        </Text>
                        <View style={getStyles(["horizontalline"])} id='horizontalline'></View>
                    </View>
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'spaBookingMainContainerChildContainer'])} id='spaBookingMainContainerChildContainer'>
                    {bookingObj?.selectedService && <>
                        <View style={getStyles(["spaBookingTechnicalDetailsContainer"])} id='spaBookingTechnicalDetailsContainer'>
                            <View style={getStyles(["spaBookingTechnicalDetailsTimeContainer"])} id='spaBookingTechnicalDetailsTimeContainer'>
                                <Text style={getStyles(["spaBookingTechnicalDetailsTimeTitle"])} id='spaBookingTechnicalDetailsTimeTitle'>{t("spaBooking.date")} </Text>
                                <Text style={getStyles(["spaBookingTechnicalDetailsTimeText"])} id='spaBookingTechnicalDetailsTimeText'>
                                    {moment(bookingObj?.selectedTechnicianDetails?.availableDate).format((dateFormat).toUpperCase())}
                                </Text>
                            </View>

                            <View style={getStyles(["spaBookingTechnicalDetailsTimeContainer"])} id='spaBookingTechnicalDetailsTimeContainer'>
                                <Text style={getStyles(["spaBookingTechnicalDetailsTimeTitle"])} id='spaBookingTechnicalDetailsTimeTitle'>{t("spaBooking.time")}</Text>
                                <Text style={getStyles(["spaBookingTechnicalDetailsTimeText"])} id='spaBookingTechnicalDetailsTimeText'>
                                    {formatMinutesToTimeFormat(bookingObj?.selectedTechnicianDetails.startTime, toBool(TIME_FORMAT))}
                                </Text>
                            </View>
                        </View>

                        <View style={getStyles(["spaBookingSummaryContainer"])} id='spaBookingSummaryContainer'>
                            <View style={getStyles(["spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                                <Text style={getStyles(["spaBookingDetailsTitle"])} id='spaBookingDetailsTitle'>{t("spaBooking.details")}</Text>

                                <View style={getStyles([ "list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                                    <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>{t("spaBooking.treatment")}</Text>
                                    <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                        {makeStringStrictlyCapitalize(bookingObj?.selectedService.name)}
                                    </Text>
                                </View>
                                
                                <View style={getStyles([ "list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                                    <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                        {t("spaBooking.duration")}{" "}
                                    </Text>
                                    <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingDspaBookingSummaryListItemRightTextetailsDurationTitleDuration'>
                                        {bookingObj?.selectedService.service.duration} {t("spaBooking.min")}
                                    </Text>
                                </View>


                                <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'> 
                                    <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                        {t("spaBooking.therapist")}{" "}
                                    </Text>
                                    <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                        {bookingObj?.selectedTechnicianDetails.technicianName}
                                    </Text>
                                </View>
                            </View>


                            <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                                <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                    {t("spaBooking.base_price")}
                                </Text>
                                <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                    {currencyCode}{" "}
                                    {bookingObj?.selectedService.service.price}
                                </Text>
                            </View>
                            
                            <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                                <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                {t("spaBooking.enhancements")+" [" +  
                                    (bookingObj?.selectedAddon.length > 0 ?
                                        bookingObj?.selectedAddon.reduce((acc,curr,index)=>{
                                            if(bookingObj?.selectedAddon.length-1 != index){
                                                return acc+curr.name +", "
                                            }
                                            return acc+ curr.name;
                                        },"")
                                    :
                                    "No enhancement selected ")
                                    +
                                    "]"
                                    }
                                </Text>
                                <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                    {currencyCode}{" "}
                                    {bookingObj?.selectedAddon.reduce((acc,curr) => {  
                                        return acc+ curr.price;
                                    }, 0)}
                                </Text>
                            </View>


                            <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                                <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                    {t("spaBooking.therapist_cost")}
                                </Text>
                                <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                    {currencyCode}{" "}
                                    {bookingObj?.selectedTechnicianDetails.technicianPrice}
                                </Text>
                            </View>


                            <View style={getStyles(["list_itemContainer", "spaBookingSummaryListItem"])} id='spaBookingSummaryListItem'>
                                <Text style={getStyles(["spaBookingSummaryListItemLeftText"])} id='spaBookingSummaryListItemLeftText'>
                                    { ( + t("spaBooking.total_price_display.showChargesLabel") ) ? t("spaBooking.total_price_display.textWithChargesLabel").replace("XX",bookingObj?.chargesDetails.tax).replace("YY", bookingObj?.chargesDetails.serviceCharge) :  t("spaBooking.total_price_display.textWithoutChargesLabel") }
                                </Text>
                                <Text style={getStyles(["spaBookingSummaryListItemRightText"])} id='spaBookingSummaryListItemRightText'>
                                    {currencyCode}{" "}
                                    {`${(bookingObj?.selectedTechnicianDetails.technicianPrice > 0
                                        ? bookingObj?.selectedService.service.price + bookingObj?.selectedTechnicianDetails.technicianPrice + bookingObj?.selectedAddon.reduce((acc,curr)=>{  return acc+ curr.price;},0)
                                        :((bookingObj?.selectedService.service.price + bookingObj?.selectedAddon.reduce((acc,curr)=>{  return acc+ curr.price;},0))) || "")
                                        }`}
                                    <Text style={getStyles([""])}>{t("spaBooking.per_person")}</Text>
                                </Text>
                            </View>

                        </View>
                    </>}
                </View>
                
            </ScrollView>


            <View id='spaBookingNextButtonContainer' style={getStyles(['spaBookingNextButtonContainer'])}>
                <CustomPressable 
                    style={getStyles(['primaryBtn'])} 
                    onPress={() => handleGoNext()} 
                    id="primaryBtn"
                >
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                        {bookingObj?.updateReservationDetails ? t("spaBooking.update_reservation_button") : t("spaBooking.make_reservation")}
                    </Text>
                </CustomPressable>

                <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoBack}>
                    <Text style={getStyles(['secondaryBtnTxt'])}>{t('spaBooking.back')}</Text>
                </CustomPressable>
            </View>
        </View>
    )
}

export default SpaBookingSummary
